import { Action } from 'redux';
import { PurlFormState, SendReferralFormState } from '../interfaces/purl.interface';

/*
 * This payload state: purl
*/
export const PURL_STATE = 'purl';
const INITIAL_STATE: PurlFormState = {
  sendReferral: {} as SendReferralFormState
};

export class PayloadAction implements Action {
  type: string;
  partialState?: any;
}

export const PATCH_PURL_STATE = 'PATCH_PURL_STATE';
export const PATCH_SEND_REFERRAL_STATE = 'PATCH_SEND_REFERRAL_STATE';
export const RESET_STATE = 'RESET_PURL_STATE';

export function patchPurlState(partialState: any): PayloadAction {
  return {
    type: PATCH_PURL_STATE,
    partialState: partialState
  };
}
export function patchSendReferralState(partialState: any): PayloadAction {
  return {
    type: PATCH_SEND_REFERRAL_STATE,
    partialState: partialState
  };
}
export function resetPurlState(): PayloadAction {
  return {
    type: RESET_STATE
  };
}

export function purlState(state: PurlFormState = INITIAL_STATE, action: PayloadAction) {
  let copiedState = Object.assign({}, state);

  switch (action.type) {
    case PATCH_PURL_STATE:
        for (let key in action.partialState) {
          if (action.partialState.hasOwnProperty(key)) {
            copiedState[key] = action.partialState[key];
          }
        }

        return copiedState;
    case PATCH_SEND_REFERRAL_STATE:
        for (let key in action.partialState) {
          if (action.partialState.hasOwnProperty(key)) {
            copiedState.sendReferral[key] = action.partialState[key];
          }
        }

        return copiedState;
    case RESET_STATE:
        return INITIAL_STATE;
    default:
        return state;
  }
}

